import type { LocationsResponse, StatusResponse, WeatherResponse } from "./types";

const now = new Date("2026-06-19T20:00:00.000Z");

export const mockLocations: LocationsResponse = {
  start: new Date(now.getTime() - 4 * 60 * 60 * 1000).toISOString(),
  end: now.toISOString(),
  locations: [
    point("mock-1", -45, 49.2827, -123.1207),
    point("mock-2", -35, 49.284, -123.116),
    point("mock-3", -25, 49.2872, -123.112),
    point("mock-gap", -90, 49.279, -123.13),
    point("mock-4", -10, 49.289, -123.108)
  ]
};

export const mockStatus: StatusResponse = {
  latestLocation: mockLocations.locations[mockLocations.locations.length - 1]!,
  latestRecordedAt: mockLocations.locations[mockLocations.locations.length - 1]!.recordedAt,
  latestServerReceivedAt: new Date(now.getTime() - 9 * 60 * 1000).toISOString(),
  latestHeartbeatAt: new Date(now.getTime() - 2 * 60 * 1000).toISOString(),
  batteryPercentage: 81,
  trackingActive: true,
  currentSessionId: "mock-session",
  latestSessionStartedAt: mockLocations.locations[0]!.recordedAt,
  latestSessionEndedAt: null,
  quickMessage: "I'm Good",
  quickMessageRecordedAt: new Date(now.getTime() - 6 * 60 * 1000).toISOString(),
  quickMessageServerReceivedAt: new Date(now.getTime() - 5 * 60 * 1000).toISOString()
};

export const mockWeather: WeatherResponse = {
  available: true,
  temperatureCelsius: 18.4,
  precipitationMm: 0,
  precipitationProbabilityPercent: 12,
  windSpeedKph: 9.7,
  windDirectionDegrees: 240
};

function point(
  clientId: string,
  minutesFromNow: number,
  latitude: number,
  longitude: number
) {
  const recordedAt = new Date(now.getTime() + minutesFromNow * 60 * 1000);
  return {
    clientId,
    latitude,
    longitude,
    accuracyMeters: 9,
    recordedAt: recordedAt.toISOString(),
    createdAt: new Date(recordedAt.getTime() + 1000).toISOString(),
    serverReceivedAt: new Date(recordedAt.getTime() + 30_000).toISOString(),
    batteryPercentage: 81,
    speedMps: 1.4,
    altitudeMeters: 74,
    bearingDegrees: 286,
    isCharging: false,
    sessionId: "mock-session"
  };
}
